import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';

import {Caregiver} from '../models';

@Injectable()
export class CaregiverAdapter implements IAdapter<Caregiver> {
  adaptToModel(resp: Caregiver): Caregiver {
    let caregiver: Caregiver = new Caregiver();

    if (resp) {
      caregiver = resp;
    }

    return caregiver;
  }

  adaptFromModel(data: Caregiver): any {
    // Restore some values
    const dataToSend: any = Object.assign({}, data);
    dataToSend.gender = data.genderEnum;
    dataToSend.status = data.statusEnum;
    delete dataToSend.username;
    delete dataToSend.designation;
    delete dataToSend.lastLogin;
    delete dataToSend.photoUrl;
    delete dataToSend.authClientIds;
    delete dataToSend.bio;
    delete dataToSend.experience;
    delete dataToSend.qualification;
    delete dataToSend.lang;
    // delete dataToSend.relation;
    delete dataToSend.photo;
    delete dataToSend.genderEnum;
    delete dataToSend.statusEnum;
    delete dataToSend.externalId;
    delete dataToSend.cancerType;
    delete dataToSend.comorbidity;
    delete dataToSend.dietPlanId;
    delete dataToSend.waConsentTime;
    delete dataToSend.selfOnbOn;
    if (Object(dataToSend).hasOwnProperty("isSelfOnb")) {
      delete dataToSend.isSelfOnb;
    }
    return dataToSend;
  }
}
